import { Box, Divider, Link, Typography } from '@mui/material';
import * as React from 'react';
import remarkGfm from 'remark-gfm'

import './Docs.css'

import Markdown from 'react-markdown';
import { LinkSx } from '../../@shared/templates';
import { MarkdownBoxStyles } from '../../@shared/markdown';

const docs = require('./Docs.md');
const examples = require('./Examples.md');

export const Docs = () => {

  const [markdown, setMarkdown] = React.useState("");
  const [examplesMarkdown, setExamplesMarkdown] = React.useState("");

  React.useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const interval = setInterval(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          clearInterval(interval);
        }
      }, 200);

      setTimeout(() => clearInterval(interval), 5000);
    }
  }, []);

  React.useEffect(() => {
    fetch(docs)
      .then((res) => res.text())
      .then((text) => setMarkdown(text.replaceAll("{{BASE_URL}}", window.location.origin)));
  }, []);

  React.useEffect(() => {
    fetch(examples)
      .then((res) => res.text())
      .then((text) => setExamplesMarkdown(text.replaceAll("{{BASE_URL}}", window.location.origin)));
  }, []);

  const flatten = (e: string, c: any): any => {
    return typeof c === 'string'
      ? e + c
      : React.Children.toArray(c.props.children).reduce(flatten, e)
  }

  const HeadingRenderer = (props: any) => {
    const children = React.Children.toArray(props.children)
    const text = children.reduce(flatten, '')
    const slug = text.toLowerCase().replace(/\W/g, '-')

    return React.createElement(props.node.tagName, { id: slug }, props.children)
  }

  return <Box sx={{
    padding: '20px',
    display: "flex",
    minHeight: "100%",
    maxHeight: "100%"
  }}>
    <Box className="docs-navigation" sx={{ 
      paddingRight: '10px', 
      width: "250px",
      overflowY: "scroll",
      minHeight: "100%",
      maxHeight: "100%"
      }}>
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="subtitle1" gutterBottom>
          <Link sx={LinkSx} href="/Documentation#introduction">Introduction</Link>
        </Typography>
      </div>
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#quickstart-guide">Quickstart guide</Link></Typography>
        <div className="docs-navigation-item">
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#get-token">Get token</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#create-schema">Create schema</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#collect-data">Collect data</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#train-model">Train model</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#run-model">Run model</Link></Typography>
        </div>
      </div>
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="subtitle1" gutterBottom>
          <Link sx={LinkSx} href="/Documentation#shemas">Shemas</Link>
        </Typography>
        <div className="docs-navigation-item">
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#schema-items">Schema items</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#creating-schemas">Creating Schemas</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#getting-schemas">Getting Schemas</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#getting-list-of-schemas">Getting List Of Schemas</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#deleting-schemas">Deleting Schemas</Link></Typography>
        </div>
      </div>
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="subtitle1" gutterBottom>
          <Link sx={LinkSx} href="/Documentation#data">Data</Link>
        </Typography>
        <div className="docs-navigation-item">
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#creating-dataset">Creating Dataset</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#deleting-dataset">Deleting Dataset</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#cleaning-schemas">Cleaning Schemas</Link></Typography>
        </div>
      </div>
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="subtitle1" gutterBottom>
          <Link sx={LinkSx} href="/Documentation#model-feature--orchestration-">Model Feature - Orchestration</Link>
        </Typography>
      </div>
      
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="subtitle1" gutterBottom>
          <Link sx={LinkSx} href="/Documentation#models">Models</Link>
        </Typography>
        <div className="docs-navigation-item">
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#model-states">Model States</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#model-types">Model Types</Link></Typography>
          <div className="docs-navigation-item">
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#averaged-perceptron">Averaged Perceptron</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#sdca-non-calibrated">SDCA Non Calibrated</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#sgd-non-calibrated">SGD Non Calibrated</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#linear-svm">Linear SVM</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#lbfgs-logistic-regression">LBFGS Logistic Regression</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#k-means">K Means</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#naive-bayes">Naive Bayes</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#sdca-regression">SDCA Regression</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#sdca-maximum-entropy">SDCA Maximum Entropy</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#lbfgs-poisson-regression">LBFGS Poisson Regression</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#online-gradient-descent">Online Gradient Descent</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#lbfgs-maximum-entropy">LBFGS Maximum Entropy</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#one-versus-all">One Versus All</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#pairwise-coupling">Pairwise Coupling</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#lightgbm">LightGBM</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#random-forest">Random Forest</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#lightgbm-regression">LightGBM Regression</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#random-forest-regression">Random Forest Regression</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#onnx">ONNX</Link></Typography>
            <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#neural-network">Neural Network</Link></Typography>
          </div>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#common-model-settings">Common Model Settings</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#creating-models">Creating Models</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#duplicating-models">Duplicating Models</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#upload-onnx-model">Upload ONNX Model</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#retraining-models">Retraining Models</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#recalculate-model-metrics">Recalculate Model Metrics</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#calibrating-models">Calibrating Models</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#running-models">Running Models</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#get-model">Get Model</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#get-list-of-models">Get List Of Models</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#deleting-models">Deleting Models</Link></Typography>
        </div>
      </div>
      <div className="docs-navigation-item docs-navigation-block">
        <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#examples">Examples</Link></Typography>
        <div className="docs-navigation-item">
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#binary-classification--iris-species-detection">Binary Classification</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#multiclass-text-classification--spam-detection">Multiclass Text Classification</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#regression--house-price-prediction">Regression</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#clustering--customer-segmentation">Clustering</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#time-series-forecasting--sales-prediction-with-rnn">Time Series Forecasting</Link></Typography>
          <Typography variant="body1" gutterBottom><Link sx={LinkSx} href="/Documentation#model-orchestration--chained-predictions">Model Orchestration</Link></Typography>
        </div>
      </div>
    </Box>
    <Divider orientation="vertical" flexItem sx={{ borderColor: "rgba(0, 0, 0, 0.12)" }} />
    <Box className="docs-body" sx={{
      paddingLeft: '20px',
      ...MarkdownBoxStyles,
      width: "calc(100% - 250px)",
      minWidth: "500px",
      overflowY: "scroll",
      minHeight: "100%",
      maxHeight: "100%"
    }}>
      <Markdown components={{ h1: HeadingRenderer, h2: HeadingRenderer, h3: HeadingRenderer }} remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
      <Markdown components={{ h1: HeadingRenderer, h2: HeadingRenderer, h3: HeadingRenderer }} remarkPlugins={[remarkGfm]}>{examplesMarkdown}</Markdown>
    </Box>
  </Box>
}